import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { discoveredFieldsApi } from './discovered-fields.api';
import type {
  OcrDiscoveredFieldContainersParams,
  OcrDiscoveredFieldFilesParams,
  OcrDiscoveredFieldGroupsParams,
  OcrDiscoveredFieldsListParams,
  OcrDiscoveredFieldTemplatesParams
} from '../types';

export const discoveredFieldKeys = {
  all: ['ocr-discovered-fields'] as const,
  lists: () => [...discoveredFieldKeys.all, 'list'] as const,
  list: (filters: OcrDiscoveredFieldsListParams) =>
    [...discoveredFieldKeys.lists(), filters] as const,
  metrics: () => [...discoveredFieldKeys.all, 'metrics'] as const,
  templates: (filters: OcrDiscoveredFieldTemplatesParams) =>
    [...discoveredFieldKeys.all, 'templates', filters] as const,
  containers: (filters: OcrDiscoveredFieldContainersParams) =>
    [...discoveredFieldKeys.all, 'containers', filters] as const,
  fields: (filters: OcrDiscoveredFieldGroupsParams) =>
    [...discoveredFieldKeys.all, 'fields', filters] as const,
  fieldFiles: (id: number, filters: OcrDiscoveredFieldFilesParams) =>
    [...discoveredFieldKeys.all, 'field-files', id, filters] as const
};

export const discoveredFieldQueries = {
  list: (filters: OcrDiscoveredFieldsListParams = {}) =>
    queryOptions({
      queryKey: discoveredFieldKeys.list(filters),
      queryFn: () => discoveredFieldsApi.getAll(filters),
      placeholderData: keepPreviousData
    }),

  metrics: () =>
    queryOptions({
      queryKey: discoveredFieldKeys.metrics(),
      queryFn: () => discoveredFieldsApi.metrics()
    }),

  templates: (filters: OcrDiscoveredFieldTemplatesParams = {}) =>
    queryOptions({
      queryKey: discoveredFieldKeys.templates(filters),
      queryFn: () => discoveredFieldsApi.templates(filters),
      placeholderData: keepPreviousData
    }),

  containers: (filters: OcrDiscoveredFieldContainersParams = {}) =>
    queryOptions({
      queryKey: discoveredFieldKeys.containers(filters),
      queryFn: () => discoveredFieldsApi.containers(filters),
      placeholderData: keepPreviousData
    }),

  fields: (filters: OcrDiscoveredFieldGroupsParams = {}) =>
    queryOptions({
      queryKey: discoveredFieldKeys.fields(filters),
      queryFn: () => discoveredFieldsApi.fields(filters),
      placeholderData: keepPreviousData
    }),

  fieldFiles: (id: number, filters: OcrDiscoveredFieldFilesParams = {}) =>
    queryOptions({
      queryKey: discoveredFieldKeys.fieldFiles(id, filters),
      queryFn: () => discoveredFieldsApi.fieldFiles(id, filters)
    })
};
